import BaseController from '../BaseController';
import Controller, { OnAfterFetch, OnMount, OnBeforeFetch } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FetchAPI, FieldAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { Value } from '@philips-internal/oswald-ui-core';
import { PatientCardAPI } from '@philips-emr/referring-physician-components';
import Audit from '../../app/audit';
import { Data } from '../../interfaces/data';
import { PatientListField } from '../../interfaces/patient-list';
import { PatientsListAliases } from '../../codegen';
interface Patient {
  cdPatient: string;
}

@Controller({ fragment: 'patients-list', component: 'main-layout' })
export default class PatientsListController extends BaseController {

  @Inject(PatientsListAliases.PATIENT_FETCH)
  fetchPatients: FetchAPI;

  @Inject(PatientsListAliases.FIELD_NAME_PATIENT)
  fieldNames: FieldAPI;

  @Inject(PatientsListAliases.FIELD_DATE_INITIAL)
  fieldDateInitial: FieldAPI;

  @Inject(PatientsListAliases.FIELD_DATE_FINAL)
  fieldDateFinal: FieldAPI;

  @Inject(PatientsListAliases.FILTER_PATIENTS)
  filterPatients: FilterAPI;

  @OnMount(PatientsListAliases.FILTER_PATIENTS)
  onMountFilter(event: MountEvent): void {
    const filter = event.target as FilterAPI;

    const currentDate = new Date();
    const initialDate = new Date();
    initialDate.setDate(currentDate.getDate() - 30);

    filter.setData({
      initialDate: initialDate.toISOString().split('T')[0],
      finalDate: currentDate.toISOString().split('T')[0]
    });
  }

  @OnMount({ target: PatientsListAliases.PATIENT_CARD_0 })
  onCdPatient(event: MountEvent): void {
    const patient = event.target as unknown as PatientCardAPI;
    patient.onClickCard.listen((c) => { this.onClickPatientCard(c.value) });
  }

  addValueToBodyFilter(field: string, value: string | undefined, body: Record<string, Value>): Record<string, Value> {
    if (value) {
      return { ...body, [field]: value };
    }
    return body;
  }

  onClickPatientCard(patient: Patient): void {
    const patientId = patient.cdPatient;
    applicationContext.redirect(APPLICATION_ROUTES.EXAMS_RESULTS_PATIENT, { patientId });
  }

  @OnBeforeFetch({ target: PatientsListAliases.PATIENT_FETCH })
  onBeforeFetch(event: FetchEvent): void {
    const filterValues = this.filterPatients.getRecord() as PatientListField;
    const fetchApi = event.target as FetchAPI;

    fetchApi.setParameters({
      name: filterValues.name ?? '',
      birthDate: filterValues.birthDate ?? '',
      examAvailabilityDate: filterValues.examAvailabilityDate ?? '',
      initialDate: filterValues.initialDate ?? '',
      finalDate: filterValues.finalDate ?? '',
    });
  }

  @OnAfterFetch({ target: PatientsListAliases.PATIENT_FETCH })
  onAfterFetchExams(event: FetchEvent): void {
    if (!event.data) {
      return;
    }
    Audit.filterExecutedLog(this.filterPatients.getRecord() as Data, (event.data as []).length);
  }

  @OnMount({ target: [PatientsListAliases.FIELD_DATE_INITIAL, PatientsListAliases.FIELD_DATE_FINAL] })
  onMountFieldDate(): void {
    this.setDefaultDateRange();
  }

  private setDefaultDateRange(): void {
    const currentDate = new Date();
    const initialDate = new Date();
    initialDate.setDate(currentDate.getDate() - 30);
    this.fieldDateInitial.setValue(initialDate.toISOString().split('T')[0]);
    this.fieldDateFinal.setValue(currentDate.toISOString().split('T')[0]);
  }
}
